// @flow
// ----------------------------------------------------------------------
// <copyright file='Izenda.ViewReportButton.js' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import routeUtils from 'share/utils/Izenda.RouteUtils';
import connect from 'share/enhancers/Izenda.Connect';
import classnames from 'classnames';
import { SOURCE_PATH_QUERY_KEY } from 'logic/data/Izenda.RouteConstants';
import QueryStringUtil from 'share/utils/Izenda.QueryStringUtil';
import { get } from 'lodash/fp';

const ViewReportButton = (props: any) => {
  const { localization, reportId, disabled, store, location } = props;
  const query = {};
  query[`${SOURCE_PATH_QUERY_KEY}`] = store.reportListLink || QueryStringUtil.getValueByKey(get('location.query', props), SOURCE_PATH_QUERY_KEY);

  const viewUrl = {
    pathname: routeUtils.getReportUrl('View', { id: reportId }),
    state: {
      fromQuickEdit: true
    },
    query
  };

  const buttonClasses = classnames('btn', 'btn-primary', 'btn-report-default', { disabled: disabled });
  return (
    <Link className={buttonClasses} to={viewUrl} disabled={disabled}>
      {localization.getText('REPORT_LABEL_VIEW_MODE')}
    </Link>
  );
};

ViewReportButton.propTypes = {
  reportId: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired
};

export default connect()(ViewReportButton);



// WEBPACK FOOTER //
// ./ui/modules/Reports/Buttons/Izenda.ViewReportButton.js